import { Accordion, Block } from '@aloft/toolkit-sui';

import { useState } from 'react';
import ReactMarkdown from 'react-markdown';

type Props = {
  rawText: string;
  thoughtsText?: string;
};

export const RawTextAccordion = ({ rawText, thoughtsText }: Props) => {
  const [index, setIndex] = useState<number[]>([]);

  const panels = [
    {
      id: 'raw-text',
      title: 'Raw model output',
      body: (
        <Block
          maxWidth="1000px"
          overflow="auto"
          __dangerDoNotUseSx={{ wordBreak: 'break-word' }}
        >
          <ReactMarkdown>{rawText}</ReactMarkdown>
        </Block>
      ),
    },
    ...(thoughtsText
      ? [
          {
            id: 'thoughts-text',
            title: 'Model thoughts (scratchpad)',
            body: (
              <Block
                maxWidth="1000px"
                overflow="auto"
                __dangerDoNotUseSx={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '12px' }}
              >
                {thoughtsText}
              </Block>
            ),
          },
        ]
      : []),
  ];

  return (
    <Accordion
      panels={panels}
      panelState={{ index, onChange: (i) => setIndex(i as number[]) }}
    />
  );
};
